import { z } from 'zod';
export const firstNameSchema = z.string().meta({ autocomplete: 'given-name' });
